import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
  height: 70px;
  background-color: #00a751;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  @media (max-width: 767px) {
    padding: 0 20px;
  }
`;

const Title = styled.h5`
  font-size: 24px;
  font-weight: 300;
  line-height: 32px;
  color: #fff;
`;

const CloseBtn = styled.span`
  font-size: 44px;
  font-weight: 300;
  color: #fff;
  cursor: pointer;
`;

export const ModalHeader = ({ closeModal }) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Title>{t('site.purchase.select-package.carbon.modal-title')}</Title>
      <CloseBtn onClick={closeModal}>×</CloseBtn>
    </Wrapper>
  );
};

ModalHeader.propTypes = {
  closeModal: PropTypes.func,
};
